<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="时间" class="fn-left">
            <el-date-picker v-model="listQuery.time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeTime" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetPriceHistoryLists()">查询 </el-button>
            <!-- <el-button type="info">查看走势</el-button> -->
            <el-button type="success" @click="bCreateStockPrice = true">更新股价</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="historyLists" border stripe>
        <el-table-column label="更新时间" prop="create_time" align="center" />
        <el-table-column label="总市值(万元)" align="center">
          <template slot-scope="{row}">
            <p>{{ row.market_capitalization/100/10000 | formatMoney }}</p>
          </template>
        </el-table-column>
        <el-table-column label="当前股价" align="center">
          <template slot-scope="{row}">
            <p>{{ (row.share_price/100).toFixed(4) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="附件" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 100px; height: 100px" :preview-src-list="[row.attachment]" :src="row.attachment" fit="fit" />
          </template>
        </el-table-column>
        <el-table-column label="操作人" align="center" prop="editor_name" />
      </el-table>
    </div>
    <el-dialog title="添加股价" :visible.sync="bCreateStockPrice" width="500px">
      <create-stock-price @successCBK="fnGetPriceHistoryLists()" />
    </el-dialog>
  </div>

</template>

<script>
import Tool from '@/assets/js/tool.js'

import CreateStockPrice from './CreateStockPrice'
import commondata from '@/utils/commondata'

export default {
  name: 'WaitSendStockLists',
  components: {
    CreateStockPrice
  },
  filters: {
    formatMoney: function(val) {
      return Tool.formatMoney(val, true)
    }
  },
  data() {
    return {
      lists: [],
      tableKey: 0,
      historyLists: [],
      stockTypes: commondata.STOCK_TYPE,
      bCreateStockPrice: false,
      listQuery: {
        time: '',
        begin_time: '',
        end_time: ''
      }
    }
  },
  created() {
    this.fnGetPriceHistoryLists()
  },
  methods: {
    fnGetPriceHistoryLists() {
      this.bCreateStockPrice = false
      this.$http.getSharePriceList(this.listQuery).then(res => {
        this.tableKey++
        this.historyLists = res.data
      })
    },
    fnDeleteExercise() {
      this.$confirm('是否取消发放股金？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

      }).catch(() => {

      })
    },
    findArray(list, key, value) {
      return Tool.findIndexInArryByKeyVal(list, key, value)
    },
    changeTime(val) {
      if (val != null) {
        this.listQuery.begin_time = val[0]
        this.listQuery.end_time = val[1]
      } else {
        this.listQuery.begin_time = ''
        this.listQuery.end_time = ''
        this.listQuery.time = []
      }
    },
    fnSendAllStock() {
      this.$confirm('是否确认操作一键发放股金？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.giveCapital().then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '发放成功'
            })
            this.fnGetPriceHistoryLists()
          }
        })
      }).catch(() => {

      })
    }

  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
.abow_dialog {
    display: flex;
    justify-content: center;
    align-items: Center;
    overflow: hidden;
    .el-dialog {
        margin: 0 auto !important;
        height: 90%;
        overflow: hidden;
        .el-dialog__body {
            position: absolute;
            left: 0;
            top: 60px;
            bottom: 0;
            right: 0;
            padding: 30px;
            z-index: 1;
            overflow: hidden;
            overflow-y: auto;
        }
    }
}

</style>
